import React from 'react';

import './styles.scss';

const ContactPage = () => {
	return (
		<main className={'contact'}>
			<div className={'wrapper'}>
				<h1>Contact</h1>
				<div className={'contact-block'}>
					<h2>NEW YORK</h2>
					<p>
					420 Lexington Avenue, Suite 300<br/>
					New York, NY, 10170<br/>
					Telephone: +1-212-297-6289<br/>
					peh@merchantspartners.com
					</p>
				</div>
				<div className={'contact-block'}>
					<h2>SHANGHAI</h2>
					<p>
						Jinhuan Business Park<br/>
						Bldg. 3, Suite 601<br/>
						1977 Jinshajiang Road<br/>
						Shanghai, 200030, China<br/>
						ceh@merchantspartners.com
					</p>
				</div>
			</div>
		</main>
	);
};

export default ContactPage;



// WEBPACK FOOTER //
// ./src/pages/contact/index.js